export const webviewRoutesTest = /\/webview|\/mobile-view/; // /webview OR /mobile-view
